import { useState } from "react";
import SEOMetadata from "../../components/SEOMetadata";
import { seoConfig } from "../../config/seoConfig";
import Benefits from "../../components/allModels/benefits";
import BuiltWork from "../../components/allModels/builtWork";
import EfiModel from "../../components/allModels/efiModel";
import FeatureCard from "../../components/allModels/featureCard";
import GasPowerBennar from "../../components/allModels/gasPowerBennar";
import GoFaster from "../../components/allModels/goFaster";
import MachineInfoCard from "../../components/allModels/machineInfoCard";
import BuildTuatara from "../../components/home/buildTuatara/buildTuatara";
import DealerLocator from "../../components/home/dealerLocator/dealerLocator";
import TuataraMotion from "../../assets/png/Tuatara_in_motion.png";
import Tuatara_with_trailer from "../../assets/images/Tuatara_with_trailer.JPG";
import ArielView1500E from "../../assets/png/ArielView1500E.png";
import TuataraHVAC from "../../assets/png/TuataraHVAC.png";
// import GASOLINEIMG from "../../assets/png/1000_EFI _GASOLINE.png";
// import Petrol_Vehicle_one from "../../assets/images/1000EFIImg/1000EFInewdoors1.jpg";
// import Petrol_Vehicle_two from "../../assets/images/1000EFIImg/1000EFInewdoors3.jpg";
// import Petrol_Vehicle_three from "../../assets/images/1000EFIImg/1000EFIwithNewdoors1.jpg";
// import Petrol_Vehicle_Four from "../../assets/images/1000EFIImg/1000EFIwithnewdoors2.jpg";
import usePageTitle from "../../hooks/usePageTitle";
import Petrol_Vehicle_one from "../../assets/images/New1000EFIPetrol/1000EFI_new_doors_1_HD.jpg";
import Petrol_Vehicle_two from "../../assets/images/New1000EFIPetrol/1000EFI_new_doors_3_HD.jpg";
import Petrol_Vehicle_three from "../../assets/images/New1000EFIPetrol/1000EFI_with_New_doors_1_HD.jpg";
import Petrol_Vehicle_Four from "../../assets/images/New1000EFIPetrol/1000EFI_with_new_doors_2_HD.jpg";
const OneThousandEFIModel = () => {
  usePageTitle("TU-1000EFI-2");

  const infoArray = [
    "LEADING ENGINE",
    "POWER TILT BED",
    "TRANSFORMING CARGO BED",
    "HVAC",
  ];
  const [info, setInfo] = useState([
    {
      title: "POWERFUL ENGINE",
      subTitle: "1000 CC Combustion Engine",
      dec: "The Tuatara 1000cc utility vehicle is powered by a robust 3-cylinder, 4-stroke combustion engine, designed for both power and durability. This liquid-cooled engine ensures optimal performance in tough conditions, preventing overheating during heavy use or in challenging environments.",
      dec2: "The Tuatara vehicle is equipped with a manual transmission featuring 5 forward gears and 1 reverse, giving drivers precise control over power and speed.",
      img: TuataraMotion,
    },
    {
      title: "POWER BED TILT",
      subTitle: "Power Tilt on Cargo Bed, Flat Bed, and Trailer",
      dec: "The Tuatara utility vehicle is equipped with a power tilt system that allows for easy lifting and dumping of the cargo bed, making it ideal for transporting and unloading heavy loads efficiently.",
      dec2: "When combined with a trailer, the power tilt system ensures quick and effortless loading and unloading, making Tuatara an exceptional choice for industries like agriculture, construction, and waste management, where adaptability and efficiency are crucial.",
      img: Tuatara_with_trailer,
    },

    {
      title: "EVOLVES TO YOUR CARGO",
      subTitle: "Easily Convert the Cargo Bed to a Flat Bed",
      dec: "The Tuatara is built with adaptability in mind, allowing it to easily evolve to meet the demands of any job. One of its standout features is the ability to convert the cargo bed into a flat bed, offering greater versatility for hauling larger or irregular loads. This quick-change capability makes the Tuatara ideal for industries where different tasks require flexible solutions. ",
      dec2: "Whether you need a standard cargo bed for transporting equipment or a flat bed for oversized materials, the Tuatara is designed to adjust and keep you moving efficiently.",
      img: ArielView1500E,
    },

    {
      title: "TEMPERATURE CONTROL",
      subTitle: "Maintain a Comfortable Climate",
      dec: "The Tuatara utility vehicle’s ceiling-mounted HVAC system is designed to provide superior comfort in extreme environments. Positioned overhead, it efficiently distributes air throughout the cabin, keeping occupants cool in hot weather and warm in colder conditions. This HVAC system is engineered to maximize space, making it unobtrusive while maintaining a comfortable climate, allowing operators to stay focused on the job at hand.",
      img: TuataraHVAC,
    },
  ]);

  const [machineInfo, setMachineInfo] = useState([
    {
      img: Petrol_Vehicle_two,
      title: "TU-1000EFI-2",
      subTitle:
        "3 seat gas utility vehicle featuring a powerful 1000cc combustion engine and built-in heater.",
      btnName: "EXPLORE 1000EFI",
      thumbnails: [Petrol_Vehicle_one, Petrol_Vehicle_two, Petrol_Vehicle_three, Petrol_Vehicle_Four],
      features: [
        "998cc Electronic Fuel Injection Engine",
        "2WD / 4WD Selectable Drivetrain",
        "3 Individual Seats",
        "2,200 lbs Towing Capacity",
      ],
      specSheetUrl: "/assets/pdf/tuatara1000efispec.pdf",
    },
  ]);

  const [modelInfo, setModelinfo] = useState({
    title: (
      <h1 className="flex font-[Rockwell] 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[25px] sm:text-[20px] text-[17px] font-extrabold ">
        <span className="underline  lg:decoration-[5px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] decoration-[#7ABF5B]">
          1000EFI
          <span className="underline  lg:decoration-[5px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] !decoration-[#fff]">
            {" "}
            Model
          </span>
        </span>
      </h1>
    ),
    dec: `The gas-powered Tuatara 1000 EFI is a tough, versatile utility vehicle designed for demanding tasks and
          off-road adventures. Built with all-steel construction and an advanced Electrophoresis Anti-Rust treatment,
          the Tuatara is designed to withstand the harshest environments. Its 2,200 lbs pull capacity, 2,200 lbs load
          capacity, and 1,200 lbs hydraulic lift cargo bed make it ideal for industrial, agricultural, and commercial
          uses. Additionally, its selectable 2WD/4WD drivetrain and heavy-duty suspension system ensure superior
          adaptability in rough terrain.`,
  });

  const GoFasterInfo = {
    title: "GO FARTHER, GO FASTER",
    list: ["REACH 50MPH TOP SPEEDS", "200+ MILE RANGE"],
    info: [
      `The gas-powered Tuatara 1000EFI delivers impressive performance with a top speed of 50 MPH, making it one of the most powerful utility vehicles in its class. Whether you're working on a job site or exploring off-road trails, the 1000EFI’s speed, strength, and durability ensure that you get where you need to go—fast. Its combination of power, torque, and precision engineering makes it ideal for both utility work and high-speed adventure.`,
      `The gas-powered Tuatara 1000EFI boasts an impressive 200+ mile range, making it ideal for long, demanding tasks across rugged terrains. Powered by a 69-horsepower, 1000cc engine, this utility vehicle combines power and efficiency, allowing you to cover vast distances without frequent refueling. Its all-steel construction and selectable 2WD/4WD options ensure durability and versatility, whether you're navigating tough off-road environments or working on expansive job sites. With a fuel capacity of 13.21 gallons, the Tuatara 1000EFI is built to last as long as the job requires.`,
    ],
  };

  const BenefitsInfo = [
    {
      title: "EXTENDED RANGE & POWER",
      subTitle:
        "With a range of over 200 miles and 69 horsepower, the gas-powered Tuatara is built for long days on the job without needing frequent refueling, making it ideal for demanding tasks in remote areas.",
    },
    {
      title: "HIGH LOAD & TOWING CAPACITY",
      subTitle:
        "Capable of pulling 4,500 lbs and carrying a load capacity of 2,200 lbs, it's designed to handle heavy-duty work, from construction to agriculture.",
    },
    {
      title: "TOUGH ALL-STEEL CONSTRUCTION",
      subTitle:
        "Built with all-steel construction and anti-rust treatment, the gas-powered Tuatara is engineered for durability in harsh terrains and challenging weather conditions.",
    },
  ];
  const seoData = seoConfig.us["1000EFI"];

  return (
    <>
      <SEOMetadata
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
      />
      <GasPowerBennar title={modelInfo.title} description={modelInfo.dec} />
      <EfiModel modelInfo={modelInfo} hideTitle={true} hideDescription={true} />
      <MachineInfoCard activeMachine={machineInfo} />
      <GoFaster GoFasterInfo={GoFasterInfo} />
      <Benefits BenefitsInfo={BenefitsInfo} />
      {/* <DealerLocator /> */}
      <FeatureCard />
      <BuiltWork info={info} infoArray={infoArray} />
      <BuildTuatara />
    </>
  );
};
export default OneThousandEFIModel;
